import React, { memo } from 'react';
import MapImage from 'assets/images/map.png';
function Map(props) {
    return(<img alt="Map" src={MapImage}/>);
}

export default memo(Map);